import { MouseEvent } from 'react';
import { IconWithText } from '../sections/EventFacts';
import HIHLink from './Link';
import { NewTabHint } from './NewTabHint';
import styles from './Chip.module.scss';

interface ChipProps {
  label: string;
  href?: string;
  icon?: string;
  className?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

export default function Chip({ label, href, icon, className, onClick }: ChipProps) {
  const content = icon ? (
    <IconWithText text={label} icon={icon} />
  ) : (
    <span className={styles.labelText}>{label}</span>
  );

  if (href !== '' && href !== undefined && href !== null) {
    return (
      <div className={[styles.chip, className].filter(Boolean).join(' ')}>
        <HIHLink
          href={href ?? ''}
          target="_blank"
          className={[styles.content, styles.linked].join(' ')}
          rel="noopener noreferrer"
          onClick={onClick}
        >
          {content}
          <NewTabHint />
        </HIHLink>
      </div>
    );
  } else {
    return (
      <div className={[styles.chip, className].filter(Boolean).join(' ')}>
        <div className={styles.content}>{content}</div>
      </div>
    );
  }
}
